<template>
  <div>
    <StepOne />
    <StepTwo />
    <StepThree />
    <StepFour />
    <StepFive />
    <StepSix />
    <StepSeven />
    <StepEight />
    <PrevNextBtns />
    <StepNav />
  </div>
</template>
<script>
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import StepFive from "./StepFive";
import StepSix from "./StepSix";
import StepSeven from "./StepSeven";
import StepEight from "./StepEight";
import PrevNextBtns from "./PrevNextBtns";
import StepNav from "./StepNav";

export default {
  name: "Steps",
  methods: {},
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix,
    StepSeven,
    StepEight,
    PrevNextBtns,
    StepNav,
  },
};
</script>
